import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  sin: '3-5 horas por noche armando Excel desde cero.',
  con: '15 minutos en obra usando la estructura profesional.'
}, {
  sin: 'Presupuestos informales enviados por un texto de WhatsApp.',
  con: 'Documento PDF pulido, transparente y estructurado.'
}, {
  sin: 'Malentendidos y pérdidas de dinero por imprevistos.',
  con: 'Escudo comercial con reglas de juego claras desde el día 1.'
}, {
  sin: 'El cliente desaparece o te dice que busca algo "más barato".',
  con: 'Sistema de 3 niveles que retiene al cliente en tu ecosistema.'
}, {
  sin: 'Presupuestos perdidos en el limbo por falta de seguimiento.',
  con: 'Guía de reactivación directa para cerrar más contratos.'
}, {
  sin: 'Estrés constante por la variación de precios en materiales.',
  con: 'Cláusulas de reajuste financiero inamovibles.'
}];
export function ComparisonTable() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-slate-50" data-id="element-37">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="text-center mb-8 sm:mb-16" data-id="element-39">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold mb-2 sm:mb-4 text-[#2756A6]" data-id="element-40">
            LA REALIDAD: ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl border border-gray-200 overflow-hidden text-sm sm:text-base" data-id="element-41">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-42">
            <div className="p-3 sm:p-6 text-center border-r border-gray-200" data-id="element-43">
              <h3 className="text-sm sm:text-xl font-bold text-gray-500" data-id="element-44">
                Sin el Sistema
              </h3>
            </div>
            <div className="p-3 sm:p-6 text-center bg-brand-dark" data-id="element-45">
              <h3 className="text-sm sm:text-xl font-bold text-brand-accent" data-id="element-46">
                Con el Sistema
              </h3>
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-47">
            {comparisons.map((row, index) => <motion.div key={index} initial={{
            opacity: 0,
            backgroundColor: '#ffffff'
          }} whileInView={{
            opacity: 1
          }} whileHover={{
            backgroundColor: '#fafaf9'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3
          }} className="grid grid-cols-2" data-id="element-48">
                <div className="p-3 sm:p-6 border-r border-gray-200 flex items-start" data-id="element-49">
                  <X className="w-4 h-4 sm:w-6 sm:h-6 text-red-400 mr-2 sm:mr-4 flex-shrink-0 mt-0.5" data-id="element-50" />
                  <p className="text-gray-600 font-medium" data-id="element-51">{row.sin}</p>
                </div>
                <div className="p-3 sm:p-6 flex items-start bg-brand-blue/5" data-id="element-52">
                  <Check className="w-4 h-4 sm:w-6 sm:h-6 text-green-500 mr-2 sm:mr-4 flex-shrink-0 mt-0.5" data-id="element-53" />
                  <p className="text-brand-dark font-bold" data-id="element-54">{row.con}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}